'use strict';exports.__esModule = true;var _constants = require('../constants');

var isSingleParking = function isSingleParking(count) {return count && count === 1;};
var isDoubleParking = function isDoubleParking(count) {return count && count === 'double';};
var convertParkingCount = function convertParkingCount(parkings) {return !isDoubleParking(parkings) && !isNaN(parkings) && +parkings;};

var formatSingleParkingContent = function formatSingleParkingContent(locale, translate, parkingType) {
  var parkingSpot = translate('parking', 'parkingSpot');
  var type = translate('type');
  var parkingTypeLabel = translate(parkingType);

  return locale === _constants.language.default ?
  parkingSpot + ' 1' + type + ': ' + parkingTypeLabel : ' 1 ' +
  parkingSpot + ' : ' + parkingTypeLabel;
};

var formatParkingContent = function formatParkingContent(count, translate, parkingType) {
  if (!count) {
    return '';
  }
  var parkingSpots = translate('parking', 'parkingSpots');
  var type = translate('type');
  var parkingTypeLabel = translate(parkingType);

  return count + ' ' + parkingSpots + type + ': ' + parkingTypeLabel;
};

var formatDoubleParkingContent = function formatDoubleParkingContent(translate, parkingType) {
  var doubleParkingLabel = translate('doubleParking');
  var parkingTypeLabel = translate(parkingType);

  return doubleParkingLabel + ': ' + parkingTypeLabel;
};

var constructParkingContent = function constructParkingContent(parkings, parkingType, translate, locale) {
  var isDouble = isDoubleParking(parkings);
  var parkingsCount = convertParkingCount(parkings);
  var isSingle = isSingleParking(parkingsCount);

  if (isDouble) {
    return formatDoubleParkingContent(translate, parkingType);
  }

  if (isSingle) {
    return formatSingleParkingContent(locale, translate, parkingType);
  }

  return formatParkingContent(parkingsCount, translate, parkingType);
};exports.default =

constructParkingContent;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/formatParkingsInfo.js
// module id = 3133
// module chunks = 0